import { EntityTable } from 'dexie';
import { ArrayUtil } from '../../../../utils/array.utils';
import { PageByIdsParams } from './types/createOfflineFilterOptionsRepository.types';
import OfflineFilterOptionsRepositoryUtils from './utils/offlineFilterOptionsRepository.utils';

export const createOfflineFilterOptionsRepository = <T, K extends keyof T>(
  getDatabaseTable: () => EntityTable<T, K>,
  searchFields?: (keyof T)[],
) => ({
  pageByIds: async ({ ids, skip, limit, orderBy, query }: PageByIdsParams<T>) => {
    const databaseTable = getDatabaseTable();

    const items = await databaseTable.where('id').anyOf(ids).toArray();

    const filtered = OfflineFilterOptionsRepositoryUtils.filterByQuery<T>({
      items,
      query,
      searchFields,
    });

    const ordered = OfflineFilterOptionsRepositoryUtils.sortByField(filtered, orderBy);

    const paged = ArrayUtil.paginate(ordered, skip, limit);

    return {
      count: ordered.length,
      data: paged,
    };
  },
});
